export const departureCountries = [
  {
    label: 'Choisir un pays',
    id: '',
  },
  {
    label: 'France',
    id: 'France',
  },
  {
    label: 'Belgique',
    id: 'Belgique',
  },
  {
    label: 'Canada',
    id: 'Canada',
  },
  {
    label: 'Espagne',
    id: 'Espagne',
  },
  {
    label: 'Etats Unis',
    id: 'Etats Unis',
  },
  {
    label: 'Italie',
    id: 'Italie',
  },
  {
    label: 'Luxembourg',
    id: 'Luxembourg',
  },
  {
    label: 'Pays Bas',
    id: 'Pays Bas',
  },
  {
    label: 'Portugal',
    id: 'Portugal',
  },
  {
    label: 'Royaume Uni',
    id: 'Royaume Uni',
  },
  {
    label: 'Suisse',
    id: 'Suisse',
  },
  {
    label: 'Guadeloupe',
    id: 'Guadeloupe',
  },
  {
    label: 'Martinique',
    id: 'Martinique',
  },
  {
    label: 'Réunion',
    id: 'Réunion',
  },
]
